import React from 'react';
import './customGridCss.scss';

export default function CustomTable({ tableInfo, defaultStyle }) {
  return (
    <div>
      <table className="dynamic-table" border="1"
       style={{ borderCollapse: 'collapse', fontSize: '20px', border: defaultStyle ? '1px solid #ffffff' : '1px solid black' }}>
       <thead>
        <tr className={defaultStyle ? 'table-row' : ''}
          style={{ ...(tableInfo?.tblRow || {}) }}
        >
          {tableInfo?.invoiceColumns?.map(col => (
            <th key={col.key} style={{ border: defaultStyle ?'1px solid #ffffff' : '1px solid black' }}>{col.label}</th>
          ))}
        </tr>
       </thead>
      <tbody>
        {tableInfo?.columnData?.map(row => (
          <tr key={row.id}
            style={{ ...(tableInfo?.tblRow || {}) }}
          >
            {tableInfo?.invoiceColumns?.map(col => (
              <td className={defaultStyle ? 'table-data' : ''} style={{ ...(tableInfo?.tblData || {}) }} key={col.key}>{row[col.key]}</td>
            ))}
          </tr>
        ))}
      </tbody>
      </table>

    </div>
  );
}
